// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b050a1a2","977":"1d9f9337"}[chunkId] + ".chunk.js";
};